import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-news",
  "use": "icon-news-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-news\"><defs><style type=\"text/css\"></style></defs><path d=\"M858.33955555 790.07288889V405.73155555l-252.47288888-107.06488888V66.67377778H124.70044445v723.39911111h-122.88v167.25333333h1020.24533333v-167.25333333H858.33955555zM257.82044445 165.66044445h204.68622222v68.26666666H257.82044445v-68.26666666z m0 167.3671111h204.68622222v68.26666667H257.82044445v-68.26666667z m0 147.79733334h204.68622222v68.26666666H257.82044445v-68.26666666z\" fill=\"#ffffff\" p-id=\"1802\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/news.svg
// module id = zgXw
// module chunks = 116